import React  from "react";
// import classNames from "classnames/bind";
import "react-image-crop/dist/ReactCrop.css";
import s from "./CheckBoxGroup.module.scss";
import {  FormControlLabel, Checkbox } from "@material-ui/core";
import { getMakeStyleClasses } from "../getMakeStyleClasses";

export default function CheckBoxGroup(props) {
    const classes = getMakeStyleClasses(compClasses);
    // const cx = classNames.bind(classes);
    const {list=[]} = props;

    const handleChange = (event) => {
        const {list=[]} = props;
        list.forEach((x)=>{
            if (x.key === event.target.name) {
                x.isVisible = event.target.checked
            }
        })
        props.handleCheckGroupChange(list);
    };

    return (
        <div className={s.container}>
            {
                list.map((item, index)=>{
                    return (<FormControlLabel
                        className={classes.rating}
                        key={index}
                        control={<Checkbox
                            color="primary"
                            checked={item.isVisible} onChange={handleChange} name={item.key} />}
                        label={`Show ${item.title}`}
                    />)
                })
            }
        </div>
    );
}

const compClasses = (theme) => ({
    rating: {
        "& span": {
            fontSize: '0.7rem'
        }
    },
});